import { render } from "./ContainerContent.vue?vue&type=template&id=c71368ba&scoped=true"
import script from "./ContainerContent.vue?vue&type=script&lang=js"
export * from "./ContainerContent.vue?vue&type=script&lang=js"

import "./ContainerContent.vue?vue&type=style&index=0&id=c71368ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71368ba"]])

export default __exports__